let parentEl = null;
let isEditMode = null;

function getTimeRemaining(endtime) {
	const total = Date.parse(endtime) - Date.parse(new Date());
	const seconds = Math.floor((total / 1000) % 60);
	const minutes = Math.floor((total / 1000 / 60) % 60);
	const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
	const days = Math.floor(total / (1000 * 60 * 60 * 24));

	return {
		days,
		hours,
		minutes
	};
}

const updateDateComponent = (timeRemaining) => {
	if (timeRemaining.days > 0) {
		parentEl.querySelector('.countdown--days').innerHTML = timeRemaining.days
	} else {
		parentEl.querySelector('.countdown__days-container').style.display = 'none'
	}

	if (timeRemaining.hours > 0 || (timeRemaining.hours == 0 && timeRemaining.days > 0)) {
		parentEl.querySelector('.countdown--hours').innerHTML = timeRemaining.hours
	} else if (timeRemaining.days <= 0) {
		parentEl.querySelector('.countdown__hours-container').style.display = 'none'
	}

	if (timeRemaining.minutes > 0 || (timeRemaining.minutes == 0 && (timeRemaining.days > 0 || timeRemaining.hours > 0))) {
		parentEl.querySelector('.countdown--minutes').innerHTML = timeRemaining.minutes
	} else if (timeRemaining.days <= 0 && timeRemaining.hours <= 0) {
		if (isEditMode == 'true') {
			parentEl.querySelector('.countdown--minutes').innerHTML = "0";
		} else {
			parentEl.style.display = 'none'
		}

		return false;
	}

	return true;
}

export default function (el) {
	parentEl = el
	isEditMode = parentEl.dataset.editMode;

	let targetDate = new Date(el.getAttribute("data-targetDate"));

	let timeRemaining = getTimeRemaining(targetDate)

	updateDateComponent(timeRemaining)

	let ticker = window.setInterval(() => {
		timeRemaining = getTimeRemaining(targetDate)

		let isTicking = updateDateComponent(timeRemaining)

		if (!isTicking) clearInterval(ticker);
	}, 1000)

}
